import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

const modals: NgbModalRef[] = [];

export const ModalStack = class ModalStack {
    
    static get isModalExists(): boolean {
            return modals.length > 0;
    }

    static addModal(modalRef: NgbModalRef) {
            modals.push(modalRef);
    }

    static closeActiveModal(data?: any) {
            const activeModal = modals.pop();
        if (activeModal) {
                activeModal.close(data);
        }
    }

    static closeModalByComponentRef(componentRef: any, data?: any) {
    
        if (!componentRef)
            return;

        const modalRef = modals.find(x => x.componentInstance == componentRef);

        if (modalRef) {
                ModalStack.closeModal(modalRef, data);
        }
    }

    static closeModal(modalRef: NgbModalRef, data?: any) {
            modals.splice(modals.indexOf(modalRef), 1);
        modalRef.close(data);
    }

    static dismissModal(modalRef: NgbModalRef, reason?: any) {
            modals.splice(modals.indexOf(modalRef), 1);
        modalRef.dismiss(reason);
    }

    static dismissAllModals(reason: any) {
            modals.forEach(x => x.dismiss(reason));
        modals.splice(0, modals.length);
    }
}